import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ResponsiveMedia from '../../../components/common/ResponsiveMedia';
import api from '../../../services/api';

export default function FeaturedWork() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.getPublicCaseStudies({ featured: '1', limit: '2' })
      .then(res => setProjects(res.case_studies || []))
      .catch(err => console.error('Error loading featured work:', err));
  }, []);

  if (projects.length === 0) return null;

  return (
    <section className="py-[100px] bg-[#030509] border-t border-[#242832]">
      <div className="w-[calc(100%-40px)] md:w-[calc(100%-64px)] max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-[32px] mb-[48px]">
          <div>
            <span className="inline-block text-[#2F6BFF] text-[12px] font-bold tracking-[0.2em] uppercase mb-4">
              Selected Engagements
            </span>
            <h2 className="text-[clamp(34px,3.8vw,54px)] font-semibold text-white leading-[1.08] tracking-[-0.035em]">
              Strategy made visible.
            </h2>
          </div>
          <Link to="/work" className="text-[13px] font-bold uppercase tracking-[0.1em] text-[#2F6BFF] hover:text-white transition-colors">
            View All Case Studies →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[32px] md:gap-[48px]">
          {projects.map((project) => (
            <Link key={project.id} to="/work" className="group block">
              <div className="aspect-[16/10] rounded-2xl overflow-hidden mb-[24px] bg-[#0B0C0F] border border-[#242832] relative">
                <ResponsiveMedia
                  src={project.image_url}
                  alt={project.client}
                  label="PROJECT IMAGE"
                  className="transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#2F6BFF] mb-2 block">
                {project.category}
              </span>
              <h3 className="text-[22px] font-semibold text-white leading-snug group-hover:text-[#2F6BFF] transition-colors mb-2">
                {project.title}
              </h3>
              <p className="text-sm text-[#A7ADB8] font-normal leading-relaxed">
                {project.summary}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
